<template>
  <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
    <defs>
      <mask id="sidebar-black-list-mask">
        <rect width="16" height="16" fill="white"/>
        <circle cx="12" cy="11.5" r="4.6" fill="black"/>
      </mask>
    </defs>
    <g mask="url(#sidebar-black-list-mask)">
      <path fill-rule="evenodd" d="M0 2H13V12H0V2ZM1.2 3.2V10.8H11.8V3.2H1.2Z"/>
      <path d="M1.1 3.2H2.6L6.5 6.3L10.4 3.2H11.9L6.5 7.6Z"/>
    </g>
    <path fill-rule="evenodd"
          d="M8.2 11.5a3.8 3.8 0 1 0 7.6 0a3.8 3.8 0 1 0 -7.6 0ZM9.3 11.5a2.7 2.7 0 1 0 5.4 0a2.7 2.7 0 1 0 -5.4 0Z"/>
    <rect x="11.45" y="8.8" width="1.1" height="5.4" transform="rotate(-45 12 11.5)"/>
  </svg>
</template>
